<template>
	<div
		v-bind="$attrs"
		class="map-modals"
		:style="layout"
	>
		<map-modal-tooltip v-if="tooltip" :order="order" />
		<map-modal-cluster-tooltip v-if="clusterTooltip" :orders="clusterOrders" />
	</div>
</template>

<script>
import MapModalTooltip from './mapModals/MapModalTooltip.vue';
import MapModalClusterTooltip from './mapModals/MapModalClusterTooltip';
import { mapDynamicState, mapDynamicGetters } from '@/core/mapDynamic';

export default {
	name: 'MapModals',
	components: {
		MapModalTooltip,
		MapModalClusterTooltip
	},
	inject: ['namespace'],
	computed: {
		...mapDynamicState('computedStoreNamespace',['mapState']),
		...mapDynamicGetters('computedStoreNamespace',['tripDetails']),
		computedStoreNamespace() {
			return `loadPlanning/${this.namespace.id}`;
		},
		layout() {
			return this.tooltip || this.clusterTooltip ? 'display: block;' : 'display: none;';
		},
		order() {
			return this.mapState.selectedOrderNode;
		},
		tooltip() {
			return this.mapState.tooltipVisible;
		},
		clusterTooltip() {
			return this.mapState.clusterTooltipVisible;
		},
		clusterOrders() {
			if (this.mapState.orderCluster) return this.mapState.orderCluster;
			return [];
		}
	},
};
</script>

<style>
.leaflet-popup {
	min-width: 320px;
	padding: 0;
	margin-top: 20px;
}

.leaflet-popup-content-wrapper {
	border-radius: 0;
	padding: 0;
	margin: 0;
}

.leaflet-popup-content {
	padding: 0;
	margin: 0 ;
	width: 100% !important;
}

.leaflet-popup-tip-container {
	padding: 0;
	border-radius: 2px;
}


.leaflet-container a.leaflet-popup-close-button {
	font-size: 22px;
	padding-top: 15px;
	padding-right: 35px;
}

.leaflet-fade-anim .leaflet-popup {
	transition: none;
}

</style>
